export default __webpack_public_path__ + "static/media/quickstart-step-4.4d41d25c.jpg";